// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"30902d09","739":"2cac5894"}[chunkId] + ".chunk.js";
};